// Adapted from Tabs.ts on NKA
// The tabs are injected into the bottom of the masthead on this site, so modifications had to be made and when no-js, the tabs don't get the active styling

import * as $ from 'jquery';

class Tabs {
	$tabs: JQuery;

	init() {
		this.$tabs = $('.tabs a') ;

		if (this.$tabs.length == 0) {
			return;
		}

		const $main = $('main');

		let inactiveTabClicked = false;

		// Click handler
		$main.on('click', 'a[role="tab"]', (event: JQuery.Event) => {
			event.preventDefault();
			//@ts-ignore TODO
			const $element = $(event.currentTarget);

			if (!inactiveTabClicked && !$element.hasClass('active')) {
				document.body.setAttribute('data-inactive-tab-clicked', 'true');
				inactiveTabClicked = true;
			}

			this.clickTab($element);
		});

		// When state changes update tabs to match
		window.addEventListener('popstate', (event) => {
			this.updateTabs();
		}, false);

		// Ensure tabs are correct on page load
		const $tabTargets = this.getHiddenTabTargets();
		const $activeTab = $tabTargets.filter('.active');
		const defaultTabId = $activeTab.length == 0 ? null : $activeTab.attr('id');
		this.updateTabs(defaultTabId);
	}

	clickTab = ($element: JQuery) => {
		const href = $element.attr('xlink\:href') || $element.attr('href');
		const hash = href.split('#')[1];

		const newHref = window.location.href.split('#')[0] + '#' + hash;

		window.history.pushState(undefined, undefined, newHref);
		this.updateTabs();
	}

	private getHiddenTabTargets() {
		return $('.tabbedContent > a[id]');
	}

	updateTabs = (defaultTabId: string = null) => {
		const hrefSplit = window.location.href.split('#');
		let tabId = defaultTabId;
		if (hrefSplit.length > 1) {
			tabId = hrefSplit[1];
		}

		const $tabTargets = this.getHiddenTabTargets();

		this.$tabs.removeClass('active');
		$tabTargets.removeClass('active');
		if (tabId !== null) {
			const $activeNavTab = this.$tabs.filter('[id="tab-' + tabId + '"]');
			if ($activeNavTab.length > 0) {
				$activeNavTab.addClass('active');
			}
			const $activeTab = $tabTargets.filter('[id="' + tabId + '"]');
			if ($activeTab.length > 0) {
				$activeTab.addClass('active');
			} else {
				tabId = null;
			}
		}

		if (tabId === null) {
			document.body.removeAttribute('active-tab');
		} else {
			document.body.setAttribute('active-tab', tabId);
			document.body.setAttribute('active-tab-index', tabId);
		}
	}
}

export default new Tabs();
